export const brandData = {
  churchName: "Urban Village Church",
  tagline: "Bold. Inclusive. Relevant.",
  missionStatement: "Urban Village Church exists to create Jesus-loving, inclusive communities that ignite the city and beyond.",
  foundedYear: 2010,
  city: "Chicago, IL",
  leadPastor: "Rev. Jonathan Grace",
  affiliations: ["United Methodist Church", "Reconciling Ministries Network"],
  sites: [
    { 
      name: "Wicker Park", 
      venue: "The Den Theatre",
      address: "1331 N. Milwaukee Ave, Chicago, IL 60622", 
      time: "Sundays 10:30 AM",
      neighborhood: "West Town (Community Area #24)", 
      vibe: "Creative arts corridor, high density, young professionals & artists",
      stats: {
        population: "~87,780",
        medianAge: "33.2 yrs",
        youngAdults: "54.2%",
        bachelorsPlus: "76.8%",
        medianIncome: "$121,450",
        renters: "58.4%",
        walkScore: "97/100"
      }
    },
    { 
      name: "Hyde Park / Woodlawn", 
      venue: "Center On Cottage Grove",
      address: "6323 S. Cottage Grove Ave, Chicago, IL 60637", 
      time: "Sundays 10:30 AM",
      neighborhood: "Hyde Park & Woodlawn (Areas #41 & #42)", 
      vibe: "Intellectual, deeply historic, civic activism, multigenerational",
      stats: {
        population: "~54,800",
        medianAge: "30.9 yrs (HP) / 33.4 (WL)",
        youngAdults: "47.8%",
        bachelorsPlus: "85.4% (HP) / 34.2% (WL)",
        medianIncome: "$64,200 (HP) / $38,900 (WL)",
        renters: "68.2% (HP) / 74.6% (WL)",
        walkScore: "88/100"
      }
    },
    { 
      name: "Ravenswood", 
      venue: "Ravenswood Fellowship UMC",
      partnership: "Co-worshiping with Ravenswood Fellowship UMC",
      address: "4511 N. Hermitage Ave, Chicago, IL 60640", 
      time: "Sundays 10:45 AM",
      neighborhood: "Lincoln Square / Ravenswood (Area #4)", 
      vibe: "Neighborhood families, LGBTQIA+ community, historic sanctuary",
      stats: {
        population: "~41,650",
        medianAge: "35.6 yrs",
        youngAdults: "43.1%",
        bachelorsPlus: "72.4%",
        medianIncome: "$94,800",
        renters: "56.1%",
        walkScore: "92/100"
      }
    },
    { 
      name: "River Forest", 
      venue: "River Forest United Methodist Church",
      partnership: "Co-worshiping with River Forest UMC",
      address: "7970 Lake St, River Forest, IL 60305", 
      time: "Sundays 10:30 AM",
      neighborhood: "Near-Western Suburban Municipality", 
      vibe: "Family-oriented, suburban accessibility, green community sanctuary",
      stats: {
        population: "~11,450",
        medianAge: "41.4 yrs",
        youngAdults: "21.6%",
        bachelorsPlus: "82.1%",
        medianIncome: "$152,300",
        renters: "14.8%",
        walkScore: "78/100"
      }
    }
  ],
  macroTrends: [
    {
      stat: "28-29%",
      title: "Religiously Unaffiliated ('Nones')",
      subtitle: "Pew Research Center (2024)",
      description: "Rises to 40%+ among young adults in Chicago. Seekers demand transparent values, authenticity, and zero political/fundamentalist dogma."
    },
    {
      stat: "79%",
      title: "Illinois LGBTQ+ Equality Support",
      subtitle: "PRRI American Values Atlas (2025/2026)",
      description: "Broad public mandate for LGBTQIA+ affirmation and non-discrimination. UVC's 14-year Reconciling leadership offers unambiguous safety."
    },
    {
      stat: "52%",
      title: "Young Adults Experiencing Loneliness",
      subtitle: "U.S. Surgeon General Advisory (2023)",
      description: "Severe urban isolation driving deep hunger for physical 'third spaces', shared meals, circle seating, and authentic neighborhood belonging."
    }
  ],
  digitalChannels: [
    { name: "Website", url: "urbanvillagechurch.org", platform: "Squarespace 7.1" },
    { name: "Livestream", handle: "@UrbanVillageChurch", platform: "YouTube & Facebook Live" },
    { name: "Podcast", handle: "uvchurch", platform: "Apple Podcasts & Podbean" },
    { name: "Instagram", handle: "@uvchurch", platform: "Instagram" }
  ],
  coreValues: [
    {
      title: "Bold",
      summary: "Rooted in a Gospel That Tears Down Walls",
      description: "We do not shy away from moral crises. We take risks for love, speak truth to power, stand alongside marginalized neighbors, and dismantle systemic oppression in our city.",
      badge: "Justice & Courage"
    },
    {
      title: "Inclusive",
      summary: "Radical Welcome for Every Human Story",
      description: "Wherever you are on your spiritual journey, you are truly welcome here. No asterisks, no fine print. We fully affirm and celebrate LGBTQIA+ persons and diverse families in all leadership.",
      badge: "Radical Hospitality"
    },
    {
      title: "Relevant",
      summary: "Beliefs as Springboards into Action",
      description: "Beliefs aren't rigid boxes to check, but springboards into imagination and meaningful action. Faith that makes sense on Monday morning and engages urban realities.",
      badge: "Dynamic & Engaged"
    }
  ],
  swot: {
    strengths: [
      "14-year proven history of LGBTQIA+ affirmation & queer leadership in the pulpit",
      "Memorable, deeply embedded 3-value anchor (Bold, Inclusive, Relevant)",
      "Clear mission to create Jesus-loving, inclusive communities that ignite the city and beyond",
      "Strategic 4-site footprint across Chicago (Wicker Park, Hyde Park, Ravenswood, River Forest)",
      "Relational, high-trust pastoral leadership team led by Rev. Jonathan Grace"
    ],
    weaknesses: [
      "Dated 2010s polygon logo mark with poor small-scale digital legibility",
      "Inconsistent visual collateral and print quality across the four sites",
      "High cognitive load and WCAG accessibility contrast friction on website",
      "Resource constraints requiring volunteer-proof, agile design templates"
    ],
    opportunities: [
      "Surging wave of deconstructing Christians & exvangelicals seeking theological safety",
      "Severe urban isolation driving demand for embodied third spaces and shared meals",
      "Civic, cultural, and artistic partnerships across Chicago theatre and mutual aid groups",
      "Enhanced audio/podcast and video livestream reach for regional seekers"
    ],
    threats: [
      "Macro societal religious disaffiliation (40%+ 'Nones' in Chicago young adult demographics)",
      "National news regarding conservative UMC schisms creating seeker confusion",
      "Intense competition within Chicago's vibrant Sunday leisure and arts economy"
    ]
  },
  personas: [
    {
      name: "Maya, 29",
      role: "The Deconstructing Seeker",
      site: "Wicker Park (The Den Theatre)",
      location: "Logan Square / Wicker Park",
      bio: "Former evangelical UX designer carrying religious trauma. Wants honest theology, queer affirmation, and zero manipulative guilt.",
      pathway: "Discovers UVC via Instagram deconstruction reels; attends at The Den Theatre with zero high-touch pressure."
    },
    {
      name: "Marcus & Jordan, 34 & 36",
      role: "The Queer Progressive Parents",
      site: "Ravenswood (Ravenswood Fellowship UMC)",
      location: "Andersonville / Ravenswood / Lincoln Square",
      bio: "Queer couple with an adopted toddler. Seeking a vibrant children's ministry and visible LGBTQIA+ leadership in the pulpit.",
      pathway: "Learns through preschool parent network; attends 10:45 AM co-worship service; feels immediate family belonging."
    },
    {
      name: "Dr. Brandon, 42",
      role: "The Intellectual Justice Activist",
      site: "Hyde Park / Woodlawn (Center On Cottage Grove)",
      location: "Hyde Park / South Side",
      bio: "University researcher and civil rights advocate. Desires bold prophetic preaching and real community mutual aid partnerships.",
      pathway: "Meets UVC members at local tenant rights rally; listens to economic justice sermon podcast; attends 6323 S Cottage Grove."
    },
    {
      name: "Elena, 23",
      role: "The Digital Nomad & Searcher",
      site: "Digital Campus / Wicker Park",
      location: "South Loop / Downtown Core",
      bio: "Entry-level analyst new to Chicago. Experiencing urban loneliness; seeking low-barrier community dinners and spiritual grounding.",
      pathway: "Watches YouTube livestreams for 2 months; joins a park cleanup project; attends in-person at The Den Theatre."
    },
    {
      name: "Eleanor & David, 65 & 68",
      role: "The Seasoned Prophetic Pillars",
      site: "River Forest (River Forest UMC)",
      location: "River Forest / Oak Park",
      bio: "Retired social worker and counselor. 40+ years in the Methodist tradition; champions intergenerational grace and Reconciling justice.",
      pathway: "Sees lawn banner at River Forest UMC; attends 10:30 AM co-worship service; engages in youth mentorship and fellowship."
    }
  ]
};
